<template>
  <div class="third-login-box show-flex-box-r show-flex-center">
    <div class="third-login-total show-flex-box-r show-flex-center" v-if="loginType != 'WX'">
      <div class="third-login-all show-flex-box-c">
        <!-- <图标 -->
        <em @click="backLoginPage()"></em>
        <dl class="third-login show-flex-bor-r show-flex-center">
          <dt class>
            <h3>第三方扫码登录</h3>
          </dt>
          <dd
            class="third-login-two-dimension-code show-flex-box-r show-flex-center"
            v-if="curThirdLoginType == 'weixin'"
          >
            <wxlogin
              style="margin-left: 50px"
              :href="wxParams.href"
              :state="wxParams.state"
              :appid="wxParams.appid"
              :scope="wxParams.scope"
              :redirect_uri="wxParams.redirect_uri"
            ></wxlogin>
          </dd>
          <dd
            class="third-login-two-dimension-code show-flex-box-r show-flex-center"
            v-if="curThirdLoginType == 'qq'"
          ></dd>
        </dl>
      </div>
    </div>
    <div class="bind-phone show-flex-box-r">
      <bind-phone-pop
        @open-set-password-pop="openSetPasswordPop"
        ref="open_bind_phone_pop"
        :bindParams="bindParams"
      ></bind-phone-pop>
    </div>
    <div class="change-password show-flex-box-r">
      <change-password
        :hasPwd="hasPwd"
        @updata-bind-success="setPasswordSuccess"
        ref="open_change_password_pop"
      ></change-password>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import wxlogin from "vue-wxlogin";
import regex from "@/filter/regex";
import bindPhonePop from "@/components/pop/my/social_bind_phone_cpn";
import changePassword from "@/components/pop/my/change_password_cpn";

export default {
  name: "third-login",
  data() {
    return {
      wxParams: {
        href:
          "data:text/css;base64,QGNoYXJzZXQgIlVURi04IjsKCi5vbGQtdGVtcGxhdGV7CiAgd2lkdGg6IDEwMCU7CiAgaGVpZ2h0OiAxMDAlOwp9CgouaW1wb3dlckJveHsKICB3aWR0aDogMTAwJTsKfQoKLmltcG93ZXJCb3ggLnRpdGxlewogIGRpc3BsYXk6IG5vbmU7Cn0KCi5pbXBvd2VyQm94IC5xcmNvZGV7CiAgd2lkdGg6IDEwMCU7CiAgYm9yZGVyOiBub25lOwogIG1hcmdpbi10b3A6IDA7Cn0KCi5pbXBvd2VyQm94IC5pbmZvewogIGRpc3BsYXk6IG5vbmU7Cn0=",
        state: "1216189",
        appid: "wx353f7d35f633ec6b", // 注册申请的appid
        scope: "snsapi_login",
        redirect_uri: encodeURI(
          'https://zgsfxg.com/web/index?loginType="WX"'
        )
      },
      WXCode: "",
      bindParams: {},
      loginType: "",
      hasPwd: true
    };
  },
  props: {
    curThirdLoginType: [String]
  },
  inject: ["reload"],
  components: {
    wxlogin,
    bindPhonePop,
    changePassword
  },
  created() {
    this.loginType = this.$route.query.loginType || "";
    this.checkIsThirdLogin();
  },
  methods: {
    checkIsThirdLogin: function() {
      if (this.loginType == "WX") {
        this.WXCode = this.$route.query.code || "";
        this.socialLogin();
      }
    },
    checkBindPhonePopDom: function() {
      if (!this.$refs.open_bind_phone_pop) {
        var _this = this;
        setTimeout(() => {
          _this.checkBindPhonePopDom();
        }, 300);
        return;
      }
      this.$refs.open_bind_phone_pop.colseBindPhonePop("bindPhone");
    },
    socialLogin: function() {
      var params = {
        type: "weixin",
        code: this.WXCode
      };

      this.$client
        .socialLogin(params)
        .then(res => {
          if (res.code == 200) {
            var userToken = res.data.token;
            if (userToken) {
              this.loginSucceed(userToken);
            } else {
              this.bindParams.type = "weixin";
              this.bindParams.unionid = res.data.authUserInfo.unionid;
              this.checkBindPhonePopDom();
            }
          }
        })
        .catch(err => {
          this.$router.back(-1);
        });
    },
    loginSucceed: function(token) {
      let saveTokenObj = {
        token: token
      };
      this.$store.commit("SET_TOKEN", saveTokenObj);
      this.$store.commit("LOGIN", true); //登录成功后改变登录状态
      this.$router.push({ path: "/web/index" });
      this.reload();
    },
    backLoginPage: function() {
      this.$emit("close-third-login-pop");
    },
    openBindPhone: function() {
      this.$router.push({ path: "/home/bind_account" });
    },
    openSetPasswordPop: function(bln) {
      this.hasPwd = bln;
      this.$refs.open_change_password_pop.closeChangePasswordPop();
    },
    setPasswordSuccess: function() {
      this.$router.push({ path: "/web/index" });
      this.reload();
    }
  }
};
</script>
<style lang="less" scoped>
.third-login-box {
  width: 553px;
  height: 553px;
  .third-login-total {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    .third-login-all {
      width: 513px;
      height: 501px;
      & > em {
        width: 22px;
        height: 22px;
        background: url("../../assets/login/left_arrow_icon.png") no-repeat
          center center;
        background-size: 22px 22px;
        cursor: pointer;
      }
      .third-login {
        width: 513px;
        height: 479px;
        & > dt {
          margin-top: 8px;
          width: 100%;
          & > h3 {
            width: 100%;
            height: 21px;
            font-size: 15px;
            font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
            font-weight: 600;
            color: rgba(48, 41, 41, 1);
            line-height: 21px;
            text-align: center;
          }
        }
        .third-login-two-dimension-code {
          margin: 40px auto;
          margin-top: 40px;
          width: 100%;
          height: 350px;
          & > div {
            width: 350px;
            height: 350px;
            & > img {
              width: 350px;
              height: 350px;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/login/third_login.vue